enum LimitType {
    Dollar = 'Dollar',
    Point = 'Point',
    Quantity = 'Quantity',
}

export default LimitType;
